(() => {
  const EXPIRATION_DAYS = 21;
  const CONTENT_TYPES = {
    product: 'product',
    collection: 'collection',
  };

  const excludeExpiredViews = (viewCount) => {
    const expTimestamp = Date.now() - (EXPIRATION_DAYS * 24 * 60 * 60 * 1000);
    const filterdCount = Object.entries(viewCount).reduce((acc, [key, value]) => {
      const [count, timestemp] = value;

      if (timestemp > expTimestamp) {
        acc[key] = value;
      }

      return acc;
    }, {});

    return filterdCount;
  };

  const getStorageKey = (type) => `pxt_${type}_views`;

  const getStoredViews = (type) => {
    const key = getStorageKey(type);
    const storedViewsJson = localStorage.getItem(key) || '{}';
    const storedViews = JSON.parse(storedViewsJson);
    return storedViews;
  };

  const setStoredViews = (newValue, type) => {
    const key = getStorageKey(type);
    localStorage.setItem(key, JSON.stringify(newValue));
  };

  const updateViewCount = (handle, type) => {
    const currentViewCount = getStoredViews(type);
    const nonExpiredViews = excludeExpiredViews(currentViewCount);

    const currentValue = nonExpiredViews[handle];
    const newCount = currentValue ? currentValue[0] + 1 : 1;
    const timestamp = Date.now();
    
    const newViewCount = {
      ...nonExpiredViews,
      [handle]: [newCount, timestamp]
    }

    setStoredViews(newViewCount, type);
  };

  const getPathnameHandle = (pathname) => {
    const parts = pathname.split('/');
    return parts[parts.length - 1];
  };

  const trackView = (type, pathname) => {
    const handle = getPathnameHandle(pathname);
    updateViewCount(handle, type)
  };

  const calcIntentTimeline = (timestamp) => {
    const now = Date.now();
    const sinceTimestampDays = (now - timestamp) / (24 * 60 * 60 * 1000);
    const expirationProgress = sinceTimestampDays / EXPIRATION_DAYS;
    return expirationProgress;
  };

  const calcIntentStrength = (count) => {
    if (count >= 5) return 8;
    if (count >= 2) return 15;
    return 20;
  };

  const calcIntentValue = (count, timestamp) => {
    const timeline = calcIntentTimeline(timestamp);
    const strength = calcIntentStrength(count);
    return Math.pow(2, -strength * timeline);
  };

  const getPersonalIntents = (type, limit = 10) => {
    const storedViews = getStoredViews(type);
    const intents = Object.entries(storedViews).map(([handle, [count, timestamp]]) => (
      [handle, calcIntentValue(count, timestamp)]
    ));

    const sortedIntents = intents.sort((a, b) => b[1] - a[1]);

    return sortedIntents.slice(0, limit);
  };

  const fetchAndRenderCollection = (handle, el) => {
    fetch(`/collections/${handle}?section_id=hp-personalized-products-render`)
      .then((response) => response.text())
      .then((html) => {
        el.innerHTML = html;
        new window.ProductItemColorSwatch(el.querySelector('.ProductList'));

        $(el).find('.ProductItem').each(function() {
          var $item = $(this);
          var selectedColor = $item.find('.ColorSwatch__Radio:checked').data('color-handle');
          handleColorSwitchImages($item, selectedColor);
        });
      });
  };

  const showHpLastVisited = () => {
    const products = getPersonalIntents(CONTENT_TYPES.product, 4);
    const wrapEl = document.querySelector('[data-last-visited]');

    if (products.length > 0 && wrapEl) {
      wrapEl.classList.remove('hidden');
      const promises = products.map((product) => (
        fetch(`/products/${product[0]}?section_id=hp-personalized-products-single-render`)
          .then((response) => response.text())
      ));

      Promise.all(promises)
        .then((results) => {
          const productListEl = wrapEl.querySelector('.personalized-section__products');
          const html = results.map((result) => {
            const template = document.createElement('div');
            template.innerHTML = result;
            return template.querySelector('.shopify-section').innerHTML;
          });
          productListEl.innerHTML = html.join('');
          new window.ProductItemColorSwatch(productListEl);

          $(productListEl).find('.ProductItem').each(function() {
            var $item = $(this);
            var selectedColor = $item.find('.ColorSwatch__Radio:checked').data('color-handle');
            handleColorSwitchImages($item, selectedColor);
          });
        });
    }
  };

  const showHpCollections = () => {
    const collections = getPersonalIntents(CONTENT_TYPES.collection, 2);
    const wrapEl1 = document.querySelector('[data-collection-1]');
    const wrapEl2 = document.querySelector('[data-collection-2]');

    if (collections.length > 0 && wrapEl1) {
      wrapEl1.classList.remove('hidden');
      fetchAndRenderCollection(collections[0][0], wrapEl1);
    }

    if (collections.length > 1 && wrapEl2) {
      wrapEl2.classList.remove('hidden');
      fetchAndRenderCollection(collections[1][0], wrapEl2);
    }
  };

  const personalizeHomepage = () => {
    showHpLastVisited();
    showHpCollections();
  };

  const onPageLoad = () => {
    const { pathname } = location;

    if (Shopify.designMode) return;

    if (pathname.includes('/products/')) {
      trackView(CONTENT_TYPES.product, pathname);
    } else if (pathname.includes('/collections/')) {
      trackView(CONTENT_TYPES.collection, pathname);
    } else if (pathname === '/') {
      personalizeHomepage();
    }
  };

  onPageLoad();
})();

// Clean up after a purchase
